module.exports = __webpack_public_path__ + "static/eku-bd129ab70f0e3e00e10588bc2741bb5c.png";